module.exports = __webpack_public_path__ + "img/video-plus.4528e9c2.svg";